/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuColorSelect_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterColor_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterColor_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuColorSelect_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterColor_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterColor_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuColorSelect_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '817409c99a5d652ed5106945b1062f60';
module.exports = node;
